import { Box } from 'juhuui';
import React, { forwardRef } from 'react';
import shallow from 'zustand/shallow';

import Therapist from '../components/therapist';
// import useWindowWidth from '../hooks/useWindowWidth';
import {
    ContainerOuter, grid12, GridHalfFull, gridM12D6, HeadingLg, MediumBright, TextMd
} from '../styles';
import { getLocalizationObj } from '../utilities/getLocalizationObj';
import { useStore } from '../zustand';

export const TherapistModule = forwardRef(
  ({ title, description, therapists = [], pricing = false }, ref) => {
    const [setModalLevel1Visible, setModalLevel1Data] = useStore(
      (state) => [state.setModalLevel1Visible, state.setModalLevel1Data],
      shallow
    );
    const changeModal = ({ id, ...rest }) => {
      setModalLevel1Data({ name: 'team', id, ...rest });
      setModalLevel1Visible(true);
    };

    return (
      <MediumBright>
        <ContainerOuter
          ref={ref}
          className={grid12}
          css={{
            bg: 'tom.bg',
            margin: 'auto',
            maxW: 'var(--max-width)',
            px: 'var(--px)',
          }}
        >
          <GridHalfFull
            css={{
              column: ['1/span 12', undefined, '1/span 5'],
              py: [6, '0'],
            }}
            fw={{ first: true }}
          >
            <Box
              css={{
                position: ['relative', undefined, 'sticky'],
                top: ['unset', undefined, '20'],
              }}
            >
              <HeadingLg
                as="h2"
                classNames="mb-6 lg:mb-20 whitespace-pre-wrap"
                // css={{
                //   mb: ['6', undefined, '20'],
                //   whiteSpace: 'pre-wrap',
                // }}
              >
                {title}
              </HeadingLg>
              <TextMd css={{ hyphens: 'auto' }}>{description}</TextMd>
            </Box>
          </GridHalfFull>
          <GridHalfFull className={gridM12D6}>
            {therapists.filter(therapistIn => {
              const therapist = getLocalizationObj(therapistIn);
              if (typeof therapist === "undefined")
                return false;
              return true;
            } ).map((therapistIn, i) => {
              const therapist = getLocalizationObj(therapistIn);
              return (
                <Therapist
                  key={therapist.id}
                  pricing
                  css={{
                    column: [
                      i % 2 ? '7/span 6' : '1/span 6',
                      undefined,
                      i % 2 ? '4/span 3' : '1/span 3',
                    ],
                    pb: ['6', undefined, '12'],
                    cursor: 'pointer',
                  }}
                  item={therapist}
                  srcsetWidthDesktop="20vw"
                  srcsetWidthMobile="48vw"
                  onClick={() => changeModal(therapist)}
                />
              );
            })}
          </GridHalfFull>
        </ContainerOuter>
      </MediumBright>
    );
  }
);
